import { render } from "./SRadio.vue?vue&type=template&id=eefa4b78&ts=true"
import script from "./SRadio.vue?vue&type=script&lang=ts"
export * from "./SRadio.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QRadio});
